"use client"

import React, {type ChangeEvent, useEffect, useState} from "react"
import {usePathname, useRouter, useSearchParams} from "next/navigation"
import useDebounce from "@/hook/useDebounce"

export default function SearchBrand() {
    const router = useRouter()
    const pathname = usePathname()
    const searchParams = useSearchParams()

    const [searchQuery, setSearchQuery] = useState("")
    const debouncedSearchQuery = useDebounce(searchQuery, 500)

    useEffect(() => {
        const currentSearch = searchParams.get("search") || ""
        if (debouncedSearchQuery === currentSearch) return

        const params = new URLSearchParams(searchParams.toString())
        if (debouncedSearchQuery) {
            params.set("search", debouncedSearchQuery)
        } else {
            params.delete("search")
        }

        router.push(`${pathname}?${params.toString()}`)
    }, [debouncedSearchQuery, pathname, router])

    const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(event.target.value)
    }

    return (
        <div className="flex w-full md:w-auto items-center justify-end">
            <input
                type="text"
                placeholder="جستجو در نام برند"
                value={searchQuery}
                onChange={handleSearchChange}
                className="md:text-base text-xs border border-[#C9C9C9] md:rounded-2xl rounded-[10px] p-[12px] focus:outline-none focus:ring-2 focus:ring-orange-500 w-full md:w-[387px] mx-4"
            />
        </div>
    )
}
